module.exports = __webpack_public_path__ + "b2f47e67ba070746eab1990f09678c99.jpg";